module.exports = __webpack_public_path__ + "static/media/cockroach.9bfca91b.jpg";